import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { CircularProgress, SvgIcon, Button } from '@mui/material';
import { Container, Row, Col, Form } from "react-bootstrap";
import BackNext from '../../Common/SubComponents/BackNext';
import { CollapsibleBasicInfoSummary } from '../Helpers/Input/CollapsibleBasicInfoSummary';
import AdditionalBenifitsInput from "../Helpers/Input/AdditionalBenifitsInput";
import StyledRadio from "../Helpers/Input/StyledRadio";
import PlanInput from "../Helpers/Input/PlanInput";
import { PENNSYLVANIA, CONNECTICUT, NORTH_DAKOTA, NEW_YORK, INDIANA, COLORADO, LOUISIANA, MINNESOTA, IOWA, DISTRICT_OF_COLUMBIA, ARKANSAS, OHIO, VERMONT, ARIZONA, IDAHO, NEWMEXICO, VIRGIN_ISLANDS, WEST_VIRGINIA, MARYLAND } from '../../../Helpers/Constants/States';
import Age from '../../../Helpers/Dates/Age';
import Aflac_Choice from "../icons/Aflac_Choice.png";
import Aflac from "../icons/Aflac.png";
import Child_Me from '../icons/Child_Me.svg?react';
import Family_Me from '../icons/Family_Me.svg?react';
import Spouse_Me from '../icons/Spouse_Me.svg?react';
import Me from '../icons/Me.svg?react';
import Download from '../icons/download.svg?react';
import { getBrochure, getMedicareGuideBrochure, getStateSpecificMedicareGuideBrochure } from "../Helpers/Brochures";
import { getSessionStorageItem, SESSION_STORAGE_AFLAC_QUOTE } from '../../../../sessionStorage';

export default function Quoter(props) {
    const { state, hsaAccount } = props.basicInfo;
    const isHSA = hsaAccount;
    const planData = [
        {
            title: "Just me",
            subTitle: "Individual",
            amount: null,
            unit: "mo",
            icon: Me,
            field: "individualPremium",
        },
        {
            title: "My children and me",
            subTitle: "One-parent family",
            amount: null,
            unit: "mo",
            icon: Child_Me,
            field: "oneParentFamilyPremium",
        },
        {
            title: "My spouse and me",
            subTitle: "Named Insured/Spouse only",
            amount: null,
            unit: "mo",
            icon: Spouse_Me,
            field: "namedSpousePremium",
        },
        {
            title: "My family and me",
            subTitle: "Two-parent family",
            amount: null,
            unit: "mo",
            icon: Family_Me,
            field: "twoParentFamilyPremium",
        }
    ];

    const aflacObj = getSessionStorageItem(SESSION_STORAGE_AFLAC_QUOTE);
    const hospitalStayRider = aflacObj && aflacObj.steps.quoter.hospitalStayAndSurgicalCareRider;
    const extendedBenefitRider = aflacObj && aflacObj.steps.quoter.extendedBenefitRider;
    const getStateBenefitName = (state === ARIZONA || state === IDAHO || state === NEWMEXICO || state === VIRGIN_ISLANDS || state === WEST_VIRGINIA);
    const getStateCTBenefitName = (state === ARIZONA || state === CONNECTICUT || state === IDAHO || state === NEWMEXICO || state === VIRGIN_ISLANDS || state === WEST_VIRGINIA);
    const benifitLabelAllowedStates = [ARKANSAS, DISTRICT_OF_COLUMBIA, IOWA, OHIO, VERMONT];

    let extendedBenefitRiderChecked = false;
    let hospitalStayAndSurgicalCareRiderChecked = false;
    if (props.importantBenifits) {
        const { groundAmbulance, icuConfinment, airAmbulance, dailyHospitalConfinement, doctorVisits, labTests, diagnosticExams, surgeries, hospitalAdmissions } = props.importantBenifits;

        if (extendedBenefitRider !== null) {
            extendedBenefitRiderChecked = extendedBenefitRider;
        }
        else if (doctorVisits || labTests || diagnosticExams || groundAmbulance || airAmbulance) {
            extendedBenefitRiderChecked = true;
        }
        if (hospitalStayRider !== null) {
            hospitalStayAndSurgicalCareRiderChecked = hospitalStayRider;
        }
        else if (hospitalAdmissions || surgeries || diagnosticExams || icuConfinment || dailyHospitalConfinement) {
            hospitalStayAndSurgicalCareRiderChecked = true;
        }
    }

    const extraBenifits = [];
    let hospitalAndSurgicalCarRiderBenifitList = [];
    if (getStateBenefitName) {
        hospitalAndSurgicalCarRiderBenifitList.push({
            title: "Initial Assistance",
            amount: "$100/year"
        });
    }
    else if (state !== CONNECTICUT && state !== NEW_YORK) {
        hospitalAndSurgicalCarRiderBenifitList.push({
            title: "Hospital Admission",
            amount: "$100/year"
        });
    }
    if (state === NORTH_DAKOTA) {
        hospitalAndSurgicalCarRiderBenifitList.push({
            title: "Surgery:",
            amount: "$100 or $300/surgery"
        });
    }
    else {
        hospitalAndSurgicalCarRiderBenifitList.push({
            title: "Surgery:",
            amount: "Up to $1,000/surgery"
        });
    }
    hospitalAndSurgicalCarRiderBenifitList.push({
        title: "Invasive Diagnostic Exam:",
        amount: "$100/exam"
    });
    if (getStateCTBenefitName) {
        hospitalAndSurgicalCarRiderBenifitList.push({
            title: "Hospital Intensive Care Unit Confinement:",
            amount: "$500/day"
        });
        hospitalAndSurgicalCarRiderBenifitList.push({
            title: "Daily Hospital Confinement:",
            amount: "$100/day"
        });
    }
    else {
        hospitalAndSurgicalCarRiderBenifitList.push({
            title: "ICU Confinement:",
            amount: "$500/day"
        });
        hospitalAndSurgicalCarRiderBenifitList.push({
            title: "Daily Hospital Stay:",
            amount: "$100/day"
        });
    }
    if (props.mentalIllnessFacilityStates.includes(state)) {
        hospitalAndSurgicalCarRiderBenifitList.push({
            title: "Daily Mental Illness Facility Confinement:",
            amount: "$100/day"
        });
    }
    hospitalAndSurgicalCarRiderBenifitList = hospitalAndSurgicalCarRiderBenifitList.concat([
        {
            title: "Second Surgical Opinion: ",
            amount: "$50/year"
        }]);

    let extraBenefitsRiderBenefitList = [];
    if (getStateBenefitName) {
        extraBenefitsRiderBenefitList.push({
            title: "Physician Visit",
            amount: "$25/visit"
        });
    }
    else if (state !== CONNECTICUT) {
        extraBenefitsRiderBenefitList.push({
            title: "Doctor Visit:",
            amount: state !== COLORADO ? "$25/visit" : "$45/visit"
        });
    }
    if (getStateBenefitName) {
        extraBenefitsRiderBenefitList.push({
            title: "Laboratory Test and X-Ray:",
            amount: "$35/test"
        });
        extraBenefitsRiderBenefitList.push({
            title: "Medical Diagnostic and Imaging Exams:",
            amount: "$150/exam"
        });
    }
    else {
        extraBenefitsRiderBenefitList.push({
            title: "Lab Test:",
            amount: "$35/test"
        });
        extraBenefitsRiderBenefitList.push({
            title: "Diagnostic Exam:",
            amount: "$150/exam"
        });
    }
    extraBenefitsRiderBenefitList = extraBenefitsRiderBenefitList.concat([
        {
            title: "Ground Ambulance:",
            amount: "$200/ride"
        },
        {
            title: "Air Ambulance:",
            amount: "$2,000/ride"
        }
    ]);
    if (state !== CONNECTICUT) {
        extraBenifits.push({
            title: "Extended Benefits Rider",
            benifitList: extraBenefitsRiderBenefitList,
            premium: null,
            field: "extendedBenefitRider",
            value: extendedBenefitRiderChecked
        });
        extraBenifits.push(
            {
                title: "Hospital Stay and Surgical Care Rider",
                benifitList: hospitalAndSurgicalCarRiderBenifitList,
                premium: null,
                field: "hospitalStayAndSurgicalCareRider",
                value: hospitalStayAndSurgicalCareRiderChecked
            },
        );
    }
    else {
        extraBenifits.push({
            title: "Hospital Stay Rider",
            benifitList: [
                {
                    title: "Initial Assistance:",
                    amount: "$100/year"
                },
                {
                    title: "Hospital Intensive Care Unit Confinement:",
                    amount: "$500/day"
                },
                {
                    title: "Daily Hospital Confinement:",
                    amount: "$100/day"
                },
                {
                    title: "Daily Mental Illness Facility Confinement:",
                    amount: "$100/day"
                },
                {
                    title: "Ground Ambulance:",
                    amount: " $200/ride"
                },
                {
                    title: "Air Ambulance:",
                    amount: "$2,000/ride"
                },

            ],
            premium: null,
            field: "hospitalStayAndSurgicalCareRider",
            value: hospitalStayAndSurgicalCareRiderChecked
        });
    }
    const [quote, setQuote] = useState(null);
    const [totalPremium, setTotalPremium] = useState(null);
    const [planOptions, setPlanOptions] = useState(planData);
    const [extraBenifitOptions, setExtraBenifitOptions] = useState(extraBenifits);
    const [loading, setLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    const formMethods = useForm({
        mode: 'all',
        reValidateMode: 'all',
        defaultValues: props.formState
    });

    const { register } = formMethods;

    useEffect(() => {
        getQuotes(state === CONNECTICUT && props.formState.coverageAmount === "500" && getCoverageAmountOptions().length > 0 ? getCoverageAmountOptions()[0].value : props.formState.coverageAmount);
    }, []);

    useEffect(() => {
        const extraBenifitOptionsData = extraBenifitOptions.find(x => x.field === "extendedBenefitRider");
        const hospitalStayAndSurgicalCareRiderData = extraBenifitOptions.find(x => x.field === "hospitalStayAndSurgicalCareRider");
        const planData = planOptions.find(x => x.field === props.formState.plan);
        const form = { ...props.fullFormState };
        form.steps.quoter.extendedBenefitRiderPremium = extraBenifitOptionsData && props.formState.extendedBenefitRider ? extraBenifitOptionsData.premium : null;
        form.steps.quoter.hospitalStayAndSurgicalCareRiderPremium = hospitalStayAndSurgicalCareRiderData && props.formState.hospitalStayAndSurgicalCareRider ? hospitalStayAndSurgicalCareRiderData.premium : null;
        form.steps.quoter.planAmount = totalPremium;
        form.steps.quoter.premiumWithoutRider = planData ? planData.amount : null;
        props.onMultiFieldChange(form);
    }, [totalPremium]);

    useEffect(() => {
        const form = { ...props.fullFormState };
        if (props.formState.hospitalStayAndSurgicalCareRider === null) {
            form.steps.quoter.hospitalStayAndSurgicalCareRider = hospitalStayAndSurgicalCareRiderChecked;
            form.steps.quoter.extendedBenefitRider = extendedBenefitRiderChecked;
        }
        if (props.formState.hospitalStayAndSurgicalCareRider === null || (state === CONNECTICUT && props.formState.coverageAmount === "500")) {
            form.steps.quoter.coverageAmount = getCoverageAmountOptions().length > 0 ? getCoverageAmountOptions()[0].value : "0";
        }
        props.onMultiFieldChange(form);
    }, [register]);

    const handlePlanValueChange = (value) => {
        props.onFieldChange("plan", value);
        if (value !== props.formState.plan) {
            extraBenifitOptions.find(x => x.field === "hospitalStayAndSurgicalCareRider").premium = quote[value].hospitalStayAndSurgicalCareRider;
            if (extraBenifitOptions.find(x => x.field === "extendedBenefitRider")) {
                extraBenifitOptions.find(x => x.field === "extendedBenefitRider").premium = quote[value].extendedBenefitRider;
            }
            setExtraBenifitOptions(extraBenifitOptions);
        }
        let amount = planOptions.find(x => x.field === value).amount;
        if (extraBenifitOptions.filter(x => x.value === true).length > 0) {
            extraBenifitOptions.filter(x => x.value === true).map((data) => {
                amount = amount + data.premium;
            });
        }
        setTotalPremium(Number(amount).toFixed(2));
    };

    const handleExtraBenifitChange = (field, value) => {
        props.onFieldChange(field, value);
        let amount = planOptions.find(x => x.field === props.formState.plan).amount;
        if (field === "extendedBenefitRider" && extraBenifitOptions.find(x => x.field === "extendedBenefitRider")) {
            extraBenifitOptions.find(x => x.field === "extendedBenefitRider").value = value;
            props.onFieldChange("extendedBenefitRider", value);
        }
        else {
            extraBenifitOptions.find(x => x.field === "hospitalStayAndSurgicalCareRider").value = value;
            props.onFieldChange("hospitalStayAndSurgicalCareRider", value);
        }
        if (extraBenifitOptions.filter(x => x.value === true).length > 0) {
            extraBenifitOptions.filter(x => x.value === true).map((data) => {
                amount = amount + data.premium;
            });
        }
        setTotalPremium(Number(amount).toFixed(2));
        setExtraBenifitOptions(extraBenifitOptions);
    };

    const age = Age(props.basicInfo.birthdate);
    const handleCoverageAmountChange = (value) => {
        props.onFieldChange("coverageAmount", value);
        setLoading(true);
        getQuotes(value);
    };

    const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;
    const getQuotes = (amount) => {
        fetch(`${covrServicesUrl}/api/Aflac/GetAflacChoiceQuotes?state=${state}&age=${age}&hospitalAmount=${amount}&healthSavingsAccount=${props.basicInfo.hsaAccount}`, {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((data) => {
                if (data) {
                    planData.find(x => x.field === "individualPremium").amount = data.individualPremium.premium;
                    planData.find(x => x.field === "oneParentFamilyPremium").amount = data.oneParentFamilyPremium.premium;
                    planData.find(x => x.field === "namedSpousePremium").amount = data.namedSpousePremium.premium;
                    planData.find(x => x.field === "twoParentFamilyPremium").amount = data.twoParentFamilyPremium.premium;
                    extraBenifitOptions.find(x => x.field === "hospitalStayAndSurgicalCareRider").premium = data[props.formState.plan].hospitalStayAndSurgicalCareRider;
                    if (extraBenifitOptions.find(x => x.field === "extendedBenefitRider")) {
                        extraBenifitOptions.find(x => x.field === "extendedBenefitRider").premium = data[props.formState.plan].extendedBenefitRider;
                    }

                    let premiumAmount = planData.find(x => x.field === props.formState.plan).amount;
                    if (extraBenifitOptions.filter(x => x.value === true).length > 0) {
                        extraBenifitOptions.filter(x => x.value === true).map((data) => {
                            premiumAmount = premiumAmount + data.premium;
                        });
                    }
                    setPlanOptions(planData);
                    setQuote(data);
                    setExtraBenifitOptions(extraBenifitOptions);
                    setLoading(false);
                    setIsError(false);
                    setTotalPremium(Number(premiumAmount).toFixed(2));
                }
                else {
                    setLoading(false);
                    setIsError(true);
                }
            }).catch((e) => { setLoading(false); setIsError(true); });
    };

    const getCoverageAmountOptions = () => {
        const coverageAmount = props.coverageAmountOptions();
        if (state === CONNECTICUT && coverageAmount.length > 0 && coverageAmount[0].value === "500") { return coverageAmount.filter(x => x.value !== "500"); }
        return coverageAmount;
    };

    const handleBrochure = (isHSA, state) => {
        const brochure = getBrochure(isHSA, state);
        props.downloadPDF(brochure.option, brochure.filename);
    };

    const handleMedicareBrochure = (state) => {
        const brochure = getMedicareGuideBrochure(state);
        props.downloadPDF(brochure.option, brochure.filename);
    };

    const handleStateSpecificMedicareBrochure = (state) => {
        const brochure = getStateSpecificMedicareGuideBrochure(state);
        props.downloadPDF(brochure.option, brochure.filename);
    };

    return (
        <Container className="container-lg pt-3">
            <Form className='form-data mt-4' onSubmit={props.onNext} {...register}>
                <div className="quoter-screen">
                    <div className="mb-3 quoter-left-section">
                        <div className="left-top-block">
                            <div className="image-wrapper"><img src={Aflac_Choice} alt='aflac' /></div>
                            <h2 className='quoter-heading-left primary-color text-center' > <span>Aflac</span><strong>Choice</strong></h2>
                            <h6 className="text-center">(pays benefits per covered person)</h6>
                            <ul>
                                <li>
                                    <span className="benifit-title">{state === PENNSYLVANIA ? 'Annual Hospital Admission:' : getStateBenefitName ? 'Annual Hospital Confinement:' : 'Annual Hospital Stay:'}</span>
                                    <span className='primary-color'>Once per calendar year</span>
                                </li>

                                <StyledRadio
                                    name="coverageAmount"
                                    id="coverageAmount"
                                    label={""}
                                    value={props.formState.coverageAmount}
                                    options={getCoverageAmountOptions()}
                                    onChange={(e) => { handleCoverageAmountChange(e); }}
                                    isBlankIcon={true}
                                />
                                {state === MARYLAND && <li>
                                    <span className="benifit-title">Second Hospitalization Opinion:</span>
                                    <span className='primary-color'>$25/confinement</span>
                                </li>}
                                {!props.basicInfo.hsaAccount && (props.mentalIllnessFacilityStates.includes(state) || state === CONNECTICUT) && (
                                    <li>
                                        <span className="benifit-title">Mental Illness Facility Confinement:</span>
                                        <span className='primary-color'>${props.formState.coverageAmount}/year</span>
                                    </li>
                                )}
                                {!props.basicInfo.hsaAccount && (
                                    <li>
                                        <span className="benifit-title">{getStateBenefitName ? 'Rehabilitation Facility' : 'Rehab Visit'}:</span>
                                        <span className='primary-color'>$100/day - up to $3,000/year</span>
                                    </li>
                                )}

                                {!props.basicInfo.hsaAccount && (state === COLORADO || state === NEW_YORK) && <li>
                                    <span className="benifit-title">Emergency Room Visit:</span>
                                    <span className='primary-color'>$150/visit - up to 2 visits per year</span>
                                </li>}

                                {!props.basicInfo.hsaAccount && state === LOUISIANA && <li>
                                    <span className="benifit-title">Emergency Room Visit:</span>
                                    <span className='primary-color'>$100/visit</span>
                                </li>}

                                {!props.basicInfo.hsaAccount && state !== COLORADO && state !== LOUISIANA && state !== MINNESOTA && state !== NEW_YORK && <li>
                                    <span className="benifit-title">{getStateBenefitName ? 'Hospital Emergency Room' : 'Emergency Room Visit'}:</span>
                                    <span className='primary-color'>$100/visit - up to 2 visits per year</span>
                                </li>}

                                {!props.basicInfo.hsaAccount && <li>
                                    <span className="benifit-title">{getStateBenefitName ? 'Hospital Short-Stay' : 'Outpatient Visit'}:</span>
                                    <span className='primary-color'>$100/visit - up to 2 visits per year</span>
                                </li>}

                                {(props.basicInfo.hsaAccount && state !== NEW_YORK) && <li>
                                    <span className="benifit-title">{getStateCTBenefitName ? 'Daily Hospital Confinement' : 'Daily Hospital Stay'}:</span>
                                    <span className='primary-color'>$100/day</span>
                                </li>}
                                {(props.basicInfo.hsaAccount && state === MARYLAND) && <li>
                                    <span className="benifit-title">Outpatient Visit: </span>
                                    <span className='primary-color'>$100/visit</span>
                                </li>}
                                {(props.basicInfo.hsaAccount) && <li>
                                    <span className="benifit-title">{getStateCTBenefitName ? 'Hospital Intensive Care Unit Confinement' : 'ICU Confinement'}: </span>
                                    <span className='primary-color'>$50/day - up to 30 days per year</span>
                                </li>}
                                {(benifitLabelAllowedStates.includes(state)) && <li>
                                    <span className="benifit-title">{state === DISTRICT_OF_COLUMBIA || state === IOWA ? 'Wellbaby Hospitalization:' : 'Newborn Hospital Care:'}</span>
                                    <span className='primary-color'>$25/day - up to 5 days per year</span>
                                </li>}
                                {(props.basicInfo.hsaAccount && state === MARYLAND) && <li>
                                    <span className="benifit-title">Wellbaby Hospitalization: </span>
                                    <span className='primary-color'>$100/day</span>
                                </li>}
                                {(state === "UT" || state === IOWA) && <li>
                                    <span className="benifit-title">Childbirth:</span>
                                    <span className='primary-color'>$250/pregnancy</span>
                                </li>}
                                {state === OHIO && props.formState.coverageAmount === "500" && <li>
                                    <span className="benifit-title">Childbirth:</span>
                                    <span className='primary-color'>$125/day - up to 4 days per pregnancy</span>
                                </li>}
                                {state === OHIO && props.formState.coverageAmount === "1000" && <li>
                                    <span className="benifit-title">Childbirth:</span>
                                    <span className='primary-color'>$250/pregnancy - up to 4 days per pregnancy</span>
                                </li>}
                                {state === OHIO && props.formState.coverageAmount === "1500" && <li>
                                    <span className="benifit-title">Childbirth:</span>
                                    <span className='primary-color'>$375/pregnancy - up to 4 days per pregnancy</span>
                                </li>}
                                {state === OHIO && props.formState.coverageAmount === "2000" && <li>
                                    <span className="benifit-title">Childbirth:</span>
                                    <span className='primary-color'>$500/pregnancy - up to 4 days per pregnancy</span>
                                </li>}
                                {(!props.basicInfo.hsaAccount && state === INDIANA) && <li>
                                    <span className="benifit-title">Telemedicine Services:</span>
                                    <span className='primary-color'>$25/visit - up to 6 visits per year</span>
                                </li>}
                                {(!props.basicInfo.hsaAccount && state === NEW_YORK) && <li>
                                    <span className="benifit-title">Daily Hospital Stay:</span>
                                    <span className='primary-color'>$50/day</span>
                                </li>}

                            </ul>
                            <div>
                                <CollapsibleBasicInfoSummary
                                    gender={props.basicInfo.gender}
                                    state={props.basicInfo.state}
                                    birthdate={props.basicInfo.birthdate}
                                    showEditLink={true}
                                    hsaAccount={props.basicInfo.hsaAccount}
                                    editLinkOnClick={props.onBack}
                                    color="primary"
                                />
                            </div>
                        </div>
                        <div className="link-block-wrapper">
                            <div className="link-block">
                                <span className="download-link d-flex align-items-center" onClick={() => handleBrochure(isHSA, state)}>
                                    <SvgIcon
                                        color="primary" component={Download}
                                        className={'header-icon'} />
                                    <div>
                                        <span> Aflac Choice Brochure</span>
                                        <span className='fw-normal'>Aflac Choice Brochure and Summary of Coverage (Outline of Coverage)</span>
                                    </div>
                                </span>
                            </div>
                            <div className="link-block">
                                <span className="download-link" onClick={() => handleMedicareBrochure(state)}>
                                    <SvgIcon
                                        color="primary" component={Download}
                                        className={'header-icon'} /> Federal Standard Medicare Guide
                                </span>
                            </div>
                            {state === "MA" && <div className="link-block">
                                <span className="download-link" onClick={() => handleStateSpecificMedicareBrochure(state)}>
                                    <SvgIcon
                                        color="primary" component={Download}
                                        className={'header-icon'} />{state} Medicare Guide
                                </span>
                            </div>}
                        </div>
                    </div>
                    <div className="quoter-right-section">
                        <div className="choice-header">
                            <h4 className="title">${props.formState.coverageAmount} - Aflac Choice</h4>
                        </div>
                        <Row className="sm-gutter">
                            {loading && <div className="loading-container">
                                <CircularProgress />
                            </div>}
                            {!loading && !isError && planOptions.length > 0 && <Col xl={12} className='w-100'><h6>Desired Plan</h6></Col>}
                            {!loading && !isError && planOptions.length > 0 && planOptions.map((d, index) =>
                                <Col key={index} xl={3} sm={6} className="btn-wrapper w-100">
                                    <PlanInput
                                        title={d.title} icon={d.icon}
                                        subtitle={d.subTitle} amount={Number(d.amount).toFixed(2)}
                                        unit={d.unit}
                                        value={props.formState.plan === d.field}
                                        onClick={() => handlePlanValueChange(d.field)}
                                        mobileWide={true} />
                                </Col>
                            )}
                            {!loading && !props.basicInfo.hsaAccount && !isError && (
                                <Col xl={12} className="additional-benefits-text w-100">
                                    <h6>Additional Benefits (pays benefits per covered person)</h6>
                                    <Button variant="text" className="edit-btn" color="primary">All Benefits</Button>
                                </Col>

                            )}
                            {!loading && !isError && !props.basicInfo.hsaAccount && extraBenifitOptions.map((d, index) =>
                                <Col key={index} xl={6} md={12} className="benifit-block w-100">
                                    <AdditionalBenifitsInput
                                        title={d.title}
                                        premium={Number(d.premium).toFixed(2)}
                                        benifits={d.benifitList}
                                        mobileWide={true}
                                        value={d.value}
                                        onClick={() => handleExtraBenifitChange(d.field, !d.value)}
                                    />
                                </Col>
                            )}
                            {!loading && isError && (
                                <Row>
                                    <Col xl={12}>
                                        Please update the coverage amount or contact our support team.
                                    </Col>
                                </Row>
                            )}

                            {!loading && !isError && (<Row className="sm-gutter bottom-block" >
                                <Col sm={8} xs={6} className="left-block">
                                    <img src={Aflac} alt='aflac' />
                                    <br />
                                    <span>"We help with expenses health insurance doesn’t cover so you can focus on recovery."</span>
                                </Col><Col sm={4} xs={6} className="right-block">
                                    <h6 className="pe-0">Total Cost</h6>
                                    <span className='pe-0 total-premium primary-color'><sup>$</sup><b>{totalPremium}</b>/mo</span>
                                    <BackNext
                                        onBack={props.onBack}
                                        hideBack={true}
                                        continueLabel={{ text: "Next" }}
                                    />
                                </Col> </Row>)}
                        </Row>
                    </div>
                </div>
            </Form>
        </Container>
    );
}

Quoter.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
    basicInfo: PropTypes.object,
    fullFormState: PropTypes.object,
    coverageAmountOptions: PropTypes.func,
    importantBenifits: PropTypes.object,
    onMultiFieldChange: PropTypes.func,
    downloadPDF: PropTypes.func,
};

Quoter.DefaultFormState = (prefill = false, basicInfo = null, coverageAmount) => {
    return {
        coverageAmount: coverageAmount,
        plan: "individualPremium",
        extendedBenefitRider: null,
        hospitalStayAndSurgicalCareRider: null,
        planAmount: null,
        premiumWithoutRider: null,
        extendedBenefitRiderPremium: null,
        hospitalStayAndSurgicalCareRiderPremium: null,
    };
};
